import React from 'react';
import CSIntro from "./CSIntro";
import ContactSection from "./ContactSection";
import Footer from "./Footer"; 

const CS = () => {
  return (
    <>
      <CSIntro />
      <ContactSection />
      <Footer />
    </>
  );
};

export default CS;
